import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet, onIonViewWillEnter } from '@ionic/vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';

import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import AuthService from "@/classes/AuthService";
import { useNetworkStore } from '@/store/network';
import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const networkStore = useNetworkStore();

const showError        = ref(false)
const showSuccess = ref(false);

const checkAuthSession = () => {
    const onAuthRoute = router.currentRoute.value.meta.needsAuth
    if(!AuthService.isAuthenticated() && onAuthRoute) {
        AuthService.logout()
    }
}

const setNetworkAvailability = () => {
    // console.log(router.currentRoute.value.name)
    // console.log(networkStore.isNetworkAvailable)
    if(!networkStore.isNetworkAvailable) {
        // showSuccess.value = false;
        // showError.value = true;
        if(
            router.currentRoute.value.name !== 'BranchIndex' &&
            router.currentRoute.value.name !== 'BookingIndex' &&
            router.currentRoute.value.name !== 'BookingEdit' &&
            router.currentRoute.value.name !== 'PatientsIndex' &&
            router.currentRoute.value.name !== 'PatientsShow' &&
            router.currentRoute.value.name !== 'PatientBookingIndex' &&
            router.currentRoute.value.name !== 'PatientBookingShow'
        ) {     
            // Redirect to Branch Managmeent
            router.replace('/branches');
        }
    } else {
        showError.value = false;
        showSuccess.value = true;
        setTimeout(() => {
            window.location.reload();
        }, 1000)
    }
}

onMounted( () => {
    // setNetworkAvailability();
    checkAuthSession();
})

onIonViewWillEnter(() => {
    // setNetworkAvailability();
})

watch(
    () => networkStore.isNetworkAvailable,
    (newValue, oldValue) => {
        console.log("New: "+newValue)
        console.log("Old: "+oldValue)
        setNetworkAvailability();
    }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet), { animated: "false" }),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Confirm",
        title: "Hoooray!",
        content: "Internet Connection has been restored."
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" Oppps... No Internet Connection. ", -1)
        ]))]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})